var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Box',[_c('h2',{staticClass:"box__title"},[_vm._v(_vm._s(_vm.$t((_vm.namespace + ".title"))))]),_c('Chart',{attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }